import { SxProps } from '@mui/material';

const muiStyles: Record<string, SxProps> = {
  content: {
    display: 'flex',
    padding: '20px 24px',
  },
};

export default muiStyles;
